module.exports = __webpack_public_path__ + "static/media/background.5739c42d.avif";